import $ from 'jquery';
import React from 'react';

type Props = {
  id: string,
  name?: string,
  fileTypes?: string,
  acceptMultipleFiles?: boolean,
  
  onFilesChanged: (name: string, files: FileList, event?: React.ChangeEvent<HTMLInputElement>) => void
};

type DefaultProps = Required<Pick<Props, 'name'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class HiddenFileInput extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    name: ''
  };

  constructor (props: Props) {
    super(props);

    this.handleFilesChanged = this.handleFilesChanged.bind(this);
  }

  private handleFilesChanged (event: React.ChangeEvent<HTMLInputElement>): void {
    const {
      id,
      name,
      onFilesChanged
    } = (this.props as PropsWithDefaults);
    
    event.preventDefault();

    const files: FileList | null = event.target.files;

    if (files != null) {
      onFilesChanged(name, files, event);

      // clear the file input, so a next identical selection will also trigger the event
      $('#' + id).val('');
    }
  }

  override render (): React.ReactNode {
    const { id, fileTypes, acceptMultipleFiles } = (this.props as PropsWithDefaults);

    if (acceptMultipleFiles) {
      return (
        <input id={id}
          style={{display: 'none'}}
          type='file'
          onChange={this.handleFilesChanged}
          accept={fileTypes}
          multiple
          value=''
        />
      );
    }
    return (
      <input id={id}
        style={{display: 'none'}}
        type='file'
        onChange={this.handleFilesChanged}
        accept={fileTypes}
        value=''
      />
    );
  }
}

export default HiddenFileInput;
